<template>
    <div class="contacts-page my-container page">
        <div>
            <h1 class="header">
                {{ t('contacts') }}
            </h1>
            <div class="flex" style="margin-bottom: 40px;">
                <NuxtLink :to="contacts.telegram" class="my-btn" target="blank">
                    {{ t('telegramChannel') }}
                </NuxtLink>
            </div>
            <div class="info">
                <div class="label">{{ t('address') }}</div>
                <div class="value">
                    {{ contacts.address[locale] }}
                </div>
            </div>
            <div class="info">
                <div class="label">{{ t('phone') }}</div>
                <NuxtLink :to="`tel:${contacts.phone}`" class="value">
                    {{ contacts.phone }}
                </NuxtLink>
            </div>
            <div class="info">
                <div class="label">E-mail</div>
                <NuxtLink :to="`mailto:${contacts.email}`" class="value">
                    {{ contacts.email }}
                </NuxtLink>
            </div>
            <div class="socials">
                <a :href="entry.link" v-for="entry in contacts.socials" :key="entry.link">
                    <img :src="entry.icon" alt="">
                </a>
            </div>
        </div>
        <div>
            <h2 class="header">
                {{ t('askQuestion') }}
            </h2>

            <form class="form" @submit.prevent="sendForm">
                <BaseInput v-model="form.name" :placeholder="t('yourName')" type="text" variant="light"
                    :class="{ error: validator.name.$error }" />

                <ClientOnly>
                    <BasePhoneInput v-model="form.phone" default-country="UZ" variant="light"
                        :error="validator.phone.$error" :search-placeholder="t('enterSearchQuery')" />
                    <template #fallback>
                        <input class="base-input light" :placeholder="t('yourPhone')" disabled />
                    </template>
                </ClientOnly>

                <BaseInput v-model="form.email" :placeholder="t('yourEmail')" type="email" variant="light"
                    :class="{ error: validator.email.$error }" />

                <textarea name="question" rows="6" class="base-input light" :placeholder="t('enterYourQuestion')"
                    v-model="form.question" :class="{ error: validator.question.$error }"></textarea>
                <div class="submit-row">
                    <button class="my-btn" :class="validator.name.$error">{{ t('send') }}</button>
                </div>
            </form>

        </div>
    </div>
</template>

<script setup>
import { useVuelidate } from '@vuelidate/core'
import { required, email, helpers } from '@vuelidate/validators'
const { t, locale } = useI18n()
const { state, initStore } = useMainStore();
const { start, finish } = useLoadingIndicator()
const toast = useToast();
const rc = useRuntimeConfig()
await initStore();
const contacts = computed(() => state.home.contacts_section)
const form = reactive({
    phone: '',
    name: '',
    email: '',
    question: ''
})

const phoneMinLength = helpers.withMessage(
    () => t('fillForm'),
    (v) => !v || v.replace(/\D/g, '').length >= 9
)

const rules = computed(() => ({
    phone: { required, valid: phoneMinLength },
    name: { required },
    email: { email },
    question: { required }
}))

const validator = useVuelidate(rules, form)

async function sendForm() {
    const isValid = await validator.value.$validate()
    if (!isValid) return toast.add({
        title: t('fillForm'),
        color: 'red'
    });
    try {
        start()
        await $fetch(rc.public.api + '/api/application/ask-a-question', {
            body: form,
            method: 'POST'
        })
        toast.add({
            title: t('contactSuccess'),
        })
        resetForm()
    } catch (error) {
        toast.add({
            title: error?.data?.context?.message || error?.data?.message || t('errorOccured'),
            color: 'red'
        })
    } finally {
        finish()
    }
}
function resetForm() {
    form.phone = ''
    form.question = ''
    form.name = ''
    form.email = ''
    validator.value.$reset()
}
</script>
